//-----------------------
// create api request id
//-----------------------
export default function createAPIRequestId(request_parms) {

  let request = {
    endpoint: "",
    method: "",
  };

  if (request_parms.id !== undefined && 
    request_parms.id !== null && 
    request_parms.id !== "") {
    request.endpoint = `${request_parms.endpoint}` + `${request_parms.id}/`;
    //
    if (request_parms.partialInd) {
      request.method = "PATCH";
    } else if (request_parms.deleteInd) {
      request.method = "DELETE";
    } else {
      request.method = "PUT";
    }
  } else {
    request.endpoint = request_parms.endpoint;
    request.method = "POST";
  }
  return request;
}
